import { GetServerSideProps } from 'next';

import { logger, PageRendererComponent, prePageCall } from '@marriott/mi-headless-utils';
import { constants } from '@marriott/mi-account-components';
import operationSignatures from '../_constants/operationSignatures.json';
import { FEATURE_FLAGS, TARGETS } from '@marriott/mi-feature-flag-utils';
import { fetchFlags } from '@marriott/mi-account-components/utils';

const { NEXT_PUBLIC_ENV_KEYS } = constants;

function pageRenderer(props) {
  return <PageRendererComponent {...props} {...{ operationSignatures }} />;
}

//Any product specific page data apart from common data like session, datalayer
//can be returned from this function and the same is passed as props to the page Component
const accountSpecificData = async () => {
  const featureFlagLogo = await fetchFlags([FEATURE_FLAGS.EXPERIENCE_MCOM_LOGO_AUTOMATION], {
    target: TARGETS.APP.ACCOUNT_RENDERER,
  });

  return {
    operationSignatures: [],
    nextPublicEnvKeys: NEXT_PUBLIC_ENV_KEYS,
    featureFlagLogo,
    featureFlags: featureFlagLogo,
  };
};

global.loggerInstance = logger({}) as CallableFunction;

//Make pre page calls like session, datalayer, fetch model.json, producSpecifc data etc
//at server side and pass the data is passed as props to page component.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getServerSideProps: GetServerSideProps<any> = prePageCall(accountSpecificData, true);
export default pageRenderer;
